export enum MediaType {
    JPEG = 'image/jpeg',
    MP4 = 'video/mp4',
    PNG = 'image/png',
    WEBP = 'image/webp',
}
